mobileSize = 1199;
$(document).ready(function () {
    $(".generalmessage").prependTo(".header");
   //prepend general message into header
   if ( $("body").hasClass("generalMessageOn") ) {
       $(".generalmessage").prependTo(".header");
   }
    // Check Window Size
    const windowSize = $(window).width();
    if (windowSize < 1199) {
        $('body')
        .addClass('saffireMobileSize')
        .removeClass('saffireLargeSize');
    } if (windowSize > 1199) {
        $('body').removeClass('saffireMobileSize');
    }

    //Subscribe
    const fes = $('.social-map-wrap-container .emailSignup');
    fes.find('.emailSubmitButton').text('subscribe');
    fes.find('.inputFieldTextbox').val('');
    fes.find('.inputFieldTextbox').attr('placeholder', 'Enter email Address');
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');


    if ($(window).width() < 1200) {
        $('#siteInfoBannerWidget').prependTo('.header-bottom');

    } else {
        $('#siteInfoBannerWidget').prependTo('.header-top');

    }
    //parallax scroll
    $(window).on("load scroll", function() {
    var parallaxElement = $(".parallax-effect"),
        parallaxQuantity = parallaxElement.length;
        window.requestAnimationFrame(function() {
        for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
            windowTop = $(window).scrollTop(),
            elementTop = currentElement.offset().top,
            elementHeight = currentElement.height(),
            viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
            scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
            transform: "translate3d(0," + scrolled * -0.18 + "px, 0)"
        });
        }
    });
    });
});
$(window).load(function () {

    if ($(window).width() < 1200) {
        $('#siteInfoBannerWidget').prependTo('.header-bottom');

    } else {
        $('#siteInfoBannerWidget').prependTo('.header-top');

    }
});
$(window).resize(function () {

    if ($(window).width() < 1200) {
        $('#siteInfoBannerWidget').prependTo('.header-bottom');

    } else {
        $('#siteInfoBannerWidget').prependTo('.header-top');

    }
});

$(document).ready(function() {
    
  });